<template>
    <section class="language-item" :class="variant">
        <img :src="require(`@/assets/flags/${item.code}.png`)" class="flag">
        <span v-if="isSmall" class="uppercase-text">{{ item.code }} </span>
        <span v-else>{{ item.name }} </span>
    </section>
</template>
<script charset="utf-8">
export default {
    name: "LanguageItem",
    computed:{
        isSmall(){
            if(this.variant && this.variant === 'small'){
                return true;
            }
            return false
        }
    },
    props: {
        item: {
            type: Object,
            default() {
                return {
                    id: 1,
                    code: "pl",
                    culture: "pl-PL",
                    name: "Polski",
                    description: "Język Polski"
                }
            }
        },
        variant: {
            type: String,
            default: ""
        }
    }
}
</script>
<style lang="scss" scoped>
.language-item {
    display: flex;
    flex-direction: row;
    column-gap: 1em;
    align-items: center;

    .uppercase-text{
        text-transform: uppercase;
    }
    .flag{
        width: 30px;
    }
}

.small {
    column-gap: 0.5em;
    font-size: 0.8em;

    .flag{
        width: 25px;
    }
}
</style>